"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ZoomedImage = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importStar(require("react"));
var styled_components_1 = tslib_1.__importDefault(require("styled-components"));
var Root = styled_components_1.default.div(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n"], ["\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n"])));
var RelativeWrapper = styled_components_1.default.div(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["\n  position: relative;\n  width: 100%;\n  height: 100%;\n  overflow: hidden;\n"], ["\n  position: relative;\n  width: 100%;\n  height: 100%;\n  overflow: hidden;\n"])));
var AbsoluteWrapper = styled_components_1.default.div(templateObject_3 || (templateObject_3 = tslib_1.__makeTemplateObject(["\n  position: absolute;\n"], ["\n  position: absolute;\n"])));
exports.ZoomedImage = (0, react_1.memo)(function (_a) {
    var children = _a.children, virtualImgRectAbsolute = _a.virtualImgRectAbsolute;
    var zoomedImgStyle = (0, react_1.useMemo)(function () {
        var width = virtualImgRectAbsolute.width, height = virtualImgRectAbsolute.height, top = virtualImgRectAbsolute.top, left = virtualImgRectAbsolute.left;
        return {
            width: "".concat(width, "px"),
            height: "".concat(height, "px"),
            top: "".concat(top, "px"),
            left: "".concat(left, "px")
        };
    }, [virtualImgRectAbsolute]);
    return (react_1.default.createElement(Root, null,
        react_1.default.createElement(RelativeWrapper, null,
            react_1.default.createElement(AbsoluteWrapper, { style: zoomedImgStyle }, children))));
});
exports.ZoomedImage.displayName = 'ZoomedImage';
var templateObject_1, templateObject_2, templateObject_3;
